import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { MIN_RETAILER_COUNT } from '../../domain/retailers';

type SummaryCardTitleProps = {
  filterTopRetailers: boolean;
  setFilterTopRetailers: (checked: boolean) => void;
};

export const SummaryCardTitle = (props: SummaryCardTitleProps) => {
  return (
    <Stack
      direction="row"
      gap="1rem"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="h5">Summary</Typography>
      <FormControlLabel
        label={`Show Top ${MIN_RETAILER_COUNT} Retailers Only`}
        control={
          <Switch
            checked={props.filterTopRetailers}
            onChange={(_, checked) => props.setFilterTopRetailers(checked)}
          />
        }
      />
    </Stack>
  );
};
